import React from 'react';

const ListIcon = () => {
  return (
    <svg width="109" height="59" viewBox="0 0 109 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="43.8489" y="38" width="38.8481" height="4" fill="#C1C3C6" />
      <rect x="43.8489" y="45" width="12.5316" height="4" fill="#E6E9EC" />
      <ellipse cx="25.0502" cy="44" rx="8.77215" ry="7" fill="#4E40EF" />
      <g filter="url(#filter0_d)">
        <rect x="5" y="19" width="99" height="33" rx="6" fill="white" />
        <rect x="4.75" y="18.75" width="99.5" height="33.5" rx="6.25" stroke="#E6E9EC" strokeWidth="0.5" />
      </g>
      <rect x="36" y="30" width="31" height="4" fill="#E6E9EC" />
      <rect x="36" y="37" width="10" height="4" fill="#E6E9EC" />
      <circle cx="21" cy="36" r="7" fill="#E6E9EC" />
      <rect x="43.8489" y="22" width="38.8481" height="4" fill="#C1C3C6" />
      <rect x="43.8489" y="29" width="12.5316" height="4" fill="#E6E9EC" />
      <ellipse cx="25.0502" cy="28" rx="8.77215" ry="7" fill="#4E40EF" />
      <g filter="url(#filter1_d)">
        <rect x="5" y="3" width="99" height="33" rx="6" fill="white" />
        <rect x="4.75" y="2.75" width="99.5" height="33.5" rx="6.25" stroke="#E6E9EC" strokeWidth="0.5" />
      </g>
      <rect x="36" y="14" width="31" height="4" fill="#C1C3C6" />
      <rect x="36" y="21" width="10" height="4" fill="#E6E9EC" />
      <circle cx="21" cy="20" r="7" fill="#4E40EF" />
      <defs>
        <filter
          id="filter0_d"
          x="0.5"
          y="16.5"
          width="108"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="0.5"
          y="0.5"
          width="108"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default ListIcon;
